import React, { useState, useEffect } from "react";
import { getStorage, getDownloadURL, ref } from "firebase/storage";
import { app } from "../Firebase/Firebaseapp";
import { Link } from "react-router-dom";


const fireStorage = getStorage(app);
const Latest = ({car}) => {

  const [imageurl, setImageUrl] = useState();

  const getBooksImg = (path) => {
    return getDownloadURL(ref(fireStorage, path));
  };

  useEffect(() => {
    console.log("show car");
    getBooksImg(car.carImage).then((url) => setImageUrl(url));
  }, []);
  return (<>
    
    
    <div class=" max-w-md overflow-hidden rounded-lg bg-white shadow sm:w-[25%] mx-3 mt-2 ">
    <Link to={`/cars/${car.id}`}>
  <img
    src={imageurl}
    class="aspect-video w-full object-cover"
    alt=""
  />
  <div class="p-4">
    {/* <p class="mb-1 text-sm text-primary-500">Andrea Felsted • <time>18 Nov 2022</time></p> */}
    <h3 class="text-xl font-medium text-gray-900">{ car && car.Name} </h3>
    <h3 class="text-xl font-medium text-gray-900">Price : { car &&  car.Price} </h3>
    <p class="mt-1 text-gray-500">{ car &&  car.Description.slice(0,80)+"......."}</p>
    <div class="mt-4 flex gap-2">
      <span
        class="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-1 text-xs font-semibold text-blue-600"
      >
         { car &&  car.BodyType}
      </span>
      <span
        class="inline-flex items-center gap-1 rounded-full bg-indigo-50 px-2 py-1 text-xs font-semibold text-indigo-600"
      >
        { car &&  car.Brand}
      </span>
      <span
        class="inline-flex items-center gap-1 rounded-full bg-orange-50 px-2 py-1 text-xs font-semibold text-orange-600"
      >
        See More
      </span>
    </div>
  </div>
</Link>
</div>

    </>
  );
};

export default Latest;
